module.exports = __webpack_public_path__ + "img/11_r.00557301.jpg";